module.exports = __webpack_public_path__ + "static/netflix-tudum-5-7ca2ef08bc6294e8bd1a918fc145c312.jpg";